import React, {Component} from 'react';
import '../../styles/Home.css'
import KoszykService from "../KoszykService";
import {Link} from "react-router-dom";
import {NotificationManager} from "react-notifications";

export default class RealizacjaTPay extends Component {

    constructor(props) {
        super(props);

        this.state = {
            bilety: [],
            klientEmail: '',
            loading: true
        };
        sessionStorage.removeItem('koszyk');
        this.props.koszyk()
    }

    componentWillMount() {
        KoszykService.getTransakcja(this.props.match.params.transakcja).then(function (response) {
            sessionStorage.removeItem('platnosc');
            this.setState({bilety: response.data, klientEmail: response.data[0].klientEmail, loading: false})
        }.bind(this))
    }

    componentDidMount() {
        // KoszykService.getPotwierdzenie(this.props.match.params.transakcja).then(function (response) {
        // }.bind(this))
    }

    anulujBilet(item) {
        this.setState({loading: true});
        KoszykService.putAnulujTransakcje(item.idBi, this.props.match.params.transakcja).then(function (response) {
            this.componentWillMount();
            NotificationManager.warning("", "Bilet został anulowany ", 5000);
        }.bind(this))
    }

    checkStatus(status) {
        if (status === -1) {
            return <span style={{fontWeight: 'bold', background: '#dc3545', color: 'white', borderRadius: 5, padding: '4px 8px'}}>DO OPŁACENIA</span>
        } else {
            if (status === 0) {
                return <span style={{fontWeight: 'bold', background: '#17a2b8', color: 'white', borderRadius: 5, padding: '4px 8px'}}>REZERWACJA</span>
            } else {
                if (status === 1) {
                    return <span style={{fontWeight: 'bold', background: '#57b13c', color: 'white', borderRadius: 5, padding: '4px 8px'}}>OPŁACONY</span>
                } else {
                    if (status === 2) {
                        return <span style={{fontWeight: 'bold', background: '#ffa707', color: 'white', borderRadius: 5, padding: '4px 8px'}}>SKASOWANY</span>
                    } else {
                        if (status === -2 || status === -3) {
                            return <span style={{fontWeight: 'bold', background: '#dc3545', color: 'white', borderRadius: 5, padding: '4px 8px'}}>ANULOWANO</span>
                        } else {
                            if (status === -4) {
                                return <span style={{fontWeight: 'bold', background: '#929292', color: 'white', borderRadius: 5, padding: '4px 8px'}}>ZWRÓCONO</span>
                            } else {
                                if (status === -5) {
                                    return <span style={{fontWeight: 'bold', background: '#929292', color: 'white', borderRadius: 5, padding: '4px 8px'}}>NIEOPŁACONY</span>
                                } else {
                                    if (status === -6) {
                                        return <span style={{fontWeight: 'bold', background: '#929292', color: 'white', borderRadius: 5, padding: '4px 8px'}}>PŁAT. ZWRÓCONA</span>
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    checkWazny(item) {
        return <div><i className="fa fa-calendar"
                       style={{paddingLeft: 2, paddingRight: 2, color: '#696969'}}></i> {item.waznyDo}</div>
    }

    checkWaznyCzas(item) {
        return <div><i className="fa fa-clock-o"
                       style={{paddingLeft: 10, paddingRight: 2, color: '#696969'}}></i>{item.godz}</div>
    }

    render() {
        return <div className="container">

            <hr/>
            <div className="rezerwacjaPomyslnie" id='divToPrint'>
                <h2><i className="fa fa-2x fa-check"> </i>Dziękujemy za skorzystanie z naszych usług</h2>
                <h5 style={{padding: 10, fontWeight: 400}}>Dane zakupu oraz bilety zostaną wysłane po zaksięgowaniu
                    wpłaty na podany adres
                    e-mail: <b>{this.state.klientEmail}</b></h5>
                {sessionStorage.getItem('loggedIn') !== undefined && sessionStorage.getItem('loggedIn') !== null ?
                    <p>Aby wyświetlić wszystkie bilety przejdź do zakładki <b><Link to={'/konto/bilety/jednorazowe'}>Moje
                        bilety</Link></b></p> :
                    <h5 style={{fontWeight: 400, paddingTop: 0}}>Status swoich biletów możesz sprawdzić <Link
                        to={'/klient/transakcja=' + this.props.match.params.transakcja}><b>tutaj</b></Link>.</h5>
                }
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/koszyk/finalizacja/RealizacjaTPay.js